import React, { useEffect, useState } from "react";

import { HeroText } from '../../components';
import { Loader } from '../../components';
import {FeaturedCarousel} from '../../components'
import { PartnershipRow } from '../../components';
import { AccordionWrapper } from '../../components';
import { BaseUrl } from "../../config";

const TechContainer = () => {
  const [featuredData, setFeaturedData] = useState([])

  const listPartners = [
    require('../../assets/tech/carousel_logos/1.AWS.png'),
    require('../../assets/tech/carousel_logos/2.Azure.png'),
    require('../../assets/tech/carousel_logos/3.DELL.png'),
    require('../../assets/tech/carousel_logos/4.HP.png'),
    require('../../assets/tech/carousel_logos/5.INCREDIBUILD.png'),
    require('../../assets/tech/carousel_logos/6.OCULUS.png'),
    require('../../assets/tech/carousel_logos/7.mindmedia.png'),
    require('../../assets/tech/carousel_logos/8.nvdia.png'),
    require('../../assets/tech/carousel_logos/9.Sketchfab.png'),
    require('../../assets/tech/carousel_logos/10.Stereolabs.png'),
    require('../../assets/tech/carousel_logos/11.Tobii.png'),
    require('../../assets/tech/carousel_logos/12.Unity.png'),
    require('../../assets/tech/carousel_logos/13.Unreal.png'),
    require('../../assets/tech/carousel_logos/14.Varjo.png'),
    require('../../assets/tech/carousel_logos/15.VIVE.png')
  ]

  const heroImg = require('../../assets/tech/tech-hero.jpg');

  const arrayLoad = [
    heroImg,
    ...listPartners
  ]


  useEffect(() => {
    document.title = "Invrsion Tech"
    
    fetch(`${BaseUrl}/page?key=invrsion&slug=technology&page=technology`, {
      method: 'GET',
      headers : { 
        'Accept': 'application/json'
       }
    })
    .then(response => {
      return response.json()
    }).then((json) =>  {
      setFeaturedData(json.data.index_news.list_news);
    })
    
  }, [])
  return (
    <React.Fragment>
      
        <section className="tech">
          <HeroText 
            title="Take a look under the hood of Invrsion" 
            paragraph="See how we combine the latest and greatest tech to fuel every Full Reality experience."
            textBelow={false} 
            image={heroImg}
            alignBg="center top"
            isImage={true}
          />
       
          <div className="side--quote-wrap extra--margin">
            <h6 className="md--title side--title">3D Digital Twins digitization</h6>
            <div className="side--text">
              <p className="preset-9">
                The digitization of Invrsion’s 3D assets poses its differential basis on a standardized process and on an automated and patented methodology.
                <br/>
                The phases of the process are divided into 3 categories:
                <ul>
                  <li>Input</li>
                  <li>Processing</li>
                  <li>Output</li>
                </ul>
              </p>
              <p className="preset-9">
              To support these 3 digitization phases, Invrsion has developed a methodological industrial process of control and development that makes the production scalable.
              A series of proprietary Asset Checker Tools execute validation controls in every part of the process.<br />
              This ecosystem of processes and the physically-based rendering approach enables us to simulate all the materials that are present in nature in an accurate and photorealistic way.
              The digitization process is compliant with the most up-to-date standardized international methods issued by The Khronos 3D Commerce Working Group to lead the 3D asset towards the goal of being an “omni-experiential” asset.
              Invrsion is an active member of The Group and works weekly towards the process of industrial development of 3D Commerce together with more than 70 companies that are recognized as excellence in the tech field.
              </p>
            </div>
          </div>
          <div className="side--quote-wrap">
            <h6 className="md--title side--title">Saas Approach</h6>
            <p className="preset-9 side--text">
            From the web editor (based on Unity) to the immersive VR simulation (based on Unreal Engine), thanks to an automatic data-driven in-cloud system. Support of all the devices compatible with SteamVR/OpenVR and of the main headsets with eye-tracking functionalities (Tobii VR Pro, HTC Vive Pro Eye, Varjo VR-1, Varjo VR-2).  Photorealistic market research available through cloud-rendering technologies (no GPU required on the client’s machine) for quantitative research.
            </p>
          </div>
          <div className="side--quote-wrap">
            <h6 className="md--title side--title">Paas Vision</h6>
            <p className="preset-9 side--text">
              Build your own virtual omni-experience solution using Invrsion’s Platform as a Service, bespoke Unreal/Unity plugins, and your favorite e-commerce platforms.
              <br />
              Use a virtual space editor to envision your virtual world, buy 3D assets (layouts, fixtures templates, and 3D products) and microservices (category management tools, multi-user collaborative tools, v-commerce, VR/AR/Web output, etc.) from an open marketplace and empower your virtual business with powerful marketing automation tools (analytics, recommendations, optimization tools, etc.).
            </p>
          </div>
          <AccordionWrapper>
            
          </AccordionWrapper>
          {
            featuredData.length > 0 &&
            <FeaturedCarousel 
              featuredData={featuredData} 
              titleSection="Get up-to-date on technology updates"
              subtitle="Read about our latest tech releases and news."
              route="technology"/>
          }
        </section>
        <PartnershipRow
          arrayPartners={listPartners} 
          title="We’re proud to power our software and experiences with the best tech." 
          categoryTitle="OUR TECH NETWORK"
        />
        <Loader arrayLoad={arrayLoad} />
      
    </React.Fragment>
  );
};

export default TechContainer;
